import { CellGroup, Field,Toast,Dialog,Overlay,DatetimePicker,Button,Popup, Picker} from 'vant'

import {idCardRegex} from '@/utils/regex'
import {memberApi} from '@/api/member';

export default {
    name:"register",
    components: {
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Toast.name]:Toast,
        [Dialog.Component.name]:Dialog.Component,
        [DatetimePicker.name]: DatetimePicker,
        [Overlay.name]:Overlay,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [Button.name]:Button
    },
    data(){
        return{
            currentDate: new Date(),
            reasonListitem: ["5年", "10年", "20年", "长期有效"],
            showPickerReason: false, // 是否显示选择框
            minDate: new Date(1940,0,1),
            value:'',
            tips:false,
            username:"",
            idNum:"",
            certEffDate:"",
            idValidityPeriod:"",
            idValidity:"",
            tipMessage:"",
            showPops:false,
            regPhone:'',
            timeStartShow: false,//时间开始显示
            showPhone:''
        }
    },
    mounted(){
        Toast.setDefaultOptions({ duration: 1500 });
    },
    methods:{
        //公共方法
        nextTips(){
            if(this.$route.fullPath.indexOf("/sign-up/register")>-1){
               this.checkInfo()
            }
        },
        handleTime(value1) {
            let year = this.currentDate.getFullYear();
            var tf = function (i) { return (i < 10 ? '0' : '') + i};
            let month = tf(this.currentDate.getMonth() + 1);
            let day = tf(this.currentDate.getDate());
            value1 = year + '-' + month + '-' + day
            this.certEffDate = value1
            this.timeStartShow = false
        },
        closeTime() {
            this.timeStartShow = false
        },
        openTime() {
            this.timeStartShow = true
        },
        onConfirm(value) {
            this.idValidityPeriod = value
            if(this.idValidityPeriod === '长期有效' ){
                this.idValidity = ''
            }else if(this.idValidityPeriod === '5年'){
                this.idValidity = '5'
            }else if (this.idValidityPeriod === '10年'){
                this.idValidity = '10'
            }else if (this.idValidityPeriod === '20年'){
                this.idValidity = '20'
            }
            this.showPickerReason = false
        },
        /**
         * 校验注册人身份信息
         */
       async checkInfo(){
            if (this.username === '') {
                Toast.fail('请输入姓名');
            }else if(!(/^[\u2E80-\uFE4F|·]{2,32}$/.test(this.username))) {
                Toast('姓名输入框存在空格请重新输入')
            }else if (this.idNum === '') {
                Toast.fail('请输入身份证号');
            } else if (!idCardRegex(this.idNum)) {
                Toast.fail('请输入正确的身份证号');
           }else if(this.certEffDate === ''){
                Toast.fail('请选择身份证有效期开始时间');
            }else if(this.idValidityPeriod === ''){
                Toast.fail('请选择证件有效期');
            }else {
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '校验中'
                })
                let data = {
                    name: this.username,
                    idCard: this.idNum
                }
                try{
                    let _self = this;
                    // const res = await this.$httpUtils.postCommonUtils(memberApi.usercheck, data)
                    // Toast.clear()
                    if (true) {
                        //成功跳转
                        _self.$router.push({path:'/sign-up/register/det',query:{name:_self.username,id:_self.idNum,certEffDate:_self.certEffDate,idValidity:_self.idValidity}});
                    } else if(res.data.status ==101) {
                        _self.tips=true;
                        _self.tipMessage="未查询到匹配的实名信息";
                        setTimeout(()=>{
                            _self.tips=false
                        },1500)
                    }else if(res.data.status ==102){
                        //账号申诉提示框
                        _self.showPops = true;
                        if(res.data.data){
                            _self.regPhone = res.data.data;
                            var pat=/(\d{3})\d*(\d{4})/
                            _self.showPhone= _self.regPhone.replace(pat,'$1****$2')
                        }else{
                            _self.regPhone = "暂无"
                        }
                    }else{
                        Toast.fail('校验异常，请稍后再试。')
                    }
                }catch (e) {
                        Toast.clear();
                        Toast.fail('服务器网络波动，请稍后再试。')
                }

            }
        },
        /**
         * 身份证被注册弹框——登陆
         */
        cancelLoading(){
            this.$router.push({
                path: '/sign-up/login',
                query:{
                    phone: this.regPhone,
                },
            });
            this.showPops = false
        },
        /**
         * 身份证被注册弹框----申诉
         */
        confirmAppeal(){
            this.$router.push('/sign-up/account-appeal')
            this.showPops = false
        },
        /**
         * 忘记密码
         */
        forgetPsw(){
            this.$router.push({
                path: '/sign-up/forget-password',
                query:{
                    num: this.idNum,
                    name:this.username
                },
            });
            this.showPops = false
        }
    }
}
